export default __webpack_public_path__ + "static/media/carMarker.f37d40d0.png";